import React from 'react';
import { Link } from 'react-router-dom';

export default function StatCard({ label, value, sub, linkTo, linkLabel }) {
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
      {linkTo && <Link to={linkTo} className="stat-link">{linkLabel || 'Manage'} &rarr;</Link>}
    </div>
  );
}
